import axios from "axios";
import config from "../config";
import { TextResponse } from "./ResponseModels/TextResponse";

export async function GetTextHomeModel(idPage: string) {
  let response = null;
  response = axios
    .get<TextResponse>(config.getTextEndpoint, {
      params: {
        slug: config.apiToken + "#" + idPage,
      },
    })
    .catch((e) => {
      // TODO manage
      console.error("There was an error!", e);
    });

  return response;
}
